<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
        <g id="back.svg" @mousedown="displayWhiteTriangle" @mouseup="displayTransparentTriangle" @mouseleave="displayTransparentTriangle" @touchstart="displayWhiteTriangle" @touchend="displayTransparentTriangle">
            <rect id="長方形_11" data-name="長方形 11" class="cls-1" width="30" height="30"/>
            <path v-show="!isPushed" id="三角形_1" data-name="三角形 1" class="cls-2--normal" d="M297,150l-15-16h30Z" transform="translate(-282 -127)"/>
            <path v-show="isPushed" id="三角形_1" data-name="三角形 1" class="cls-2--pushed" d="M344,150l-15-16h30Z" transform="translate(-329 -127)"/>
        </g>
    </svg>
</template>

<script>
export default {
    data() {
        return {
            isPushed: false
        }
    },
    methods: {
        displayWhiteTriangle() {
            this.isPushed = true
        },
        displayTransparentTriangle() {
            this.isPushed = false
        }
    }
}
</script>

<style scoped>
.cls-1 {
    fill: #fff;
    opacity: 0;
}
.cls-2--normal {
    fill: none;
    stroke: #fff;
    stroke-width: 2px;
    fill-rule: evenodd;
}
.cls-2--pushed {
    fill: #fff;
    stroke: #fff;
    stroke-width: 2px;
    fill-rule: evenodd;
}
</style>